const CONST_VARIANT = {
  MUI_DEFAULT: 'MUI_DEFAULT',
  KC_DEFAULT: 'KC_DEFAULT',
  DISABLED: 'DISABLED',
}

const MUI_LICENSE = process.env.REACT_APP_MUI_LICENSE || 'commercial';

export { CONST_VARIANT, MUI_LICENSE };